module.exports = __webpack_public_path__ + "img/havanna_oak_602m_detail_rsh1.5aaef99d.jpg";